<template src='./template.html'></template>

<script>
export default {
    name: 'ApproveCard',
    props: ['approvel']
}
</script>